<template>
  <div class="position-relative">
    <div v-if="current" class="current mb-3">
      <h2 class="textStyle">{{ $t("registration.insee_company.current") }}</h2>
      <div class="row">
        <div class="col-md-6 fw-bold">{{ $t("registration.insee_company.social_reason") }}</div>
        <div class="col-md-6">{{ current.legalUnitSocialReason }}</div>
      </div>

      <div class="row">
        <div class="col-md-6 fw-bold">{{ $t("registration.insee_company.siret") }}</div>
        <div class="col-md-6">{{ current.siret }}</div>
      </div>

      <div class="row">
        <div class="col-md-6 fw-bold">{{ $t("registration.insee_company.head_office") }}</div>
        <div class="col-md-6">{{ current.establishmentHeadOffice ? $t("yes") : $t("no") }}</div>
      </div>

      <div class="row">
        <div class="col-md-6 fw-bold">{{ $t("registration.insee_company.creation_date") }}</div>
        <div class="col-md-6">{{ current.establishmentCreationDate }}</div>
      </div>

      <div class="row">
        <div class="col-md-6 fw-bold">{{ $t("registration.insee_company.work_force") }}</div>
        <div class="col-md-6">
          {{ current.establishmentWorkforce + " " + $tc("employee", 2).toLowerCase() }}
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 fw-bold">{{ $t("registration.insee_company.status") }}</div>
        <div class="col-md-6">
          <span
            class="badge"
            :class="{
              'bg-success': current.establishmentDistributionStatus === 'O',
              'bg-danger': current.establishmentDistributionStatus !== 'O',
            }"
            >{{
              current.establishmentDistributionStatus === "O"
                ? $tc("global.opened.title", 1)
                : $tc("global.closed.title", 1)
            }}</span
          >
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 fw-bold">{{ $t("registration.insee_company.activity") }}</div>
        <div class="col-md-6">
          {{ current.nafNomenclatureCompanyActivity?.label }} ({{ current.nafNomenclatureCompanyActivity?.code }})
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 fw-bold">{{ $t("registration.insee_company.principal_address") }}</div>
        <div class="col-md-6">
          {{ current.address }}<br />
          {{ current.addressComplement ? current.addressComplement + "\n" : "" }}
          {{ current.addressCity ? current.addressCity.postCode + " " + current.addressCity.name + "\n" : "" }}
        </div>
      </div>

      <div v-if="current.address2City" class="row">
        <div class="col-md-6 fw-bold">{{ $t("registration.insee_company.secondary_address") }}</div>
        <div class="col-md-6">
          {{ current.address2 }}<br />
          {{ current.address2Complement ? current.address2Complement + "\n" : "" }}
          {{ current.address2City ? current.address2City.postCode + " " + current.address2City.name + "\n" : "" }}
        </div>
      </div>
    </div>
  </div>
  <RegistrationCompanyEstablishmentListComponent
    :establishments="activities"
    :title="$tc('admin.institution.title', 2) + ' ' + $tc('global.opened.title', 3).toLowerCase()"
  />
  <RegistrationCompanyEstablishmentListComponent
    :establishments="closed"
    :title="$tc('admin.institution.title', 2) + ' ' + $tc('global.closed.title', 3).toLowerCase()"
  />
  <BlockLoader :loading="loading" />
</template>

<script>
import RegistrationCompanyEstablishmentListComponent from "@/components/registration/company/RegistrationCompanyEstablishmentListComponent.vue";
import BlockLoader from "@/components/blocks/BlockLoader.vue";

export default {
  name: "RegistrationCompanyGeneralTabComponent",
  components: { BlockLoader, RegistrationCompanyEstablishmentListComponent },
  props: {
    data: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    current() {
      return this.data.currentInseeCompany;
    },
    activities() {
      return this.data.activeCompanies;
    },
    closed() {
      return this.data.closedCompanies;
    },
  },
};
</script>

<style lang="scss" scoped>
.current {
  padding: 20px;
  border: 1px dashed $m_color_6;
  border-radius: $radius;
}

.position-relative {
  min-height: 300px;
}

.row {
  border-bottom: 1px dashed $m_color_6;
  padding: 4px 0;
  &:last-child {
    border-bottom: none;
  }

  @include up-to-md {
    border-bottom: none;
    border-top: 1px dashed $m_color_6;
    padding: 6px 0 0 0;
    margin-top: 6px;
  }
}
</style>
